export default "__VITE_ASSET__BgpSZ6_g__"